import api from '@/resources/login/api/login.api'
import menu from './data/menu'

export default (mock, result) => {
  mock.onPost(api.login).reply(config => {
    let res = {
      code: 0,
      msg: "请求成功",
      data: {
        id: 123,
        name: 'yanzi',
        token: '123456789qwertyu'
      },
    };
    return new Promise((resolve, reject) => {
      resolve([200, res])
    })
  });
}


